import { getZakupiteljById } from "../../../components/ZakupiteljChoice/api/getZakupiteljById";
import { getAllCities } from "../../groups/api/getAllCities";
import { getAllRooms } from "./getAllRooms";
import { getAllUsers } from "./getAllUsers";
import { getEvents } from "./getEvents";

export const fetchGlobalData = async ({
  authToken,
  userData,
  setAllUsers,
  setCities,
  setCitiesForSecond,
  setZakupitelj,
  setSelectedCity,
  setAllRooms,
}) => {
  try {
    const [usersResponse, citiesResponse, roomsResponse, zakupiteljResponse] =
      await Promise.all([
        getAllUsers(authToken),
        getAllCities(authToken),
        getAllRooms(authToken),
        getZakupiteljById(userData.id, authToken),
      ]);

    const mappedRooms = roomsResponse.rooms.map((room) => ({
      label: room.roomName,
      value: room.id,
      cityId: room.cityId,
    }));

    setAllRooms(mappedRooms);

    const filteredCities = citiesResponse
      .filter((city) => !["Podgorica", "Rijeka", "Split"].includes(city.label))
      .map((city) =>
        city.label === "Online" ? { ...city, label: "Online/Bez sobe" } : city
      );

    setAllUsers(usersResponse);
    setCities(filteredCities);
    setCitiesForSecond(filteredCities);

    const zakupitelj = zakupiteljResponse[0] || null;
    setZakupitelj(zakupitelj);
    const defaultCity = filteredCities.find(
      (city) => city.value === userData.defaultCity
    ) || {
      label: "Zagreb",
      value: 2,
    };

    setSelectedCity(defaultCity);
  } catch (error) {
    console.error("Error fetching global data:", error);
  }
};

export const fetchCityData = async ({
  authToken,
  selectedCity,
  allRooms,
  startDate,
  setRawEvents,
  setEvents,
  setRooms,
  setSecondRooms,
}) => {
  try {
    const filteredRooms = allRooms.filter(
      (room) => room.cityId === selectedCity.value
    );

    const resourceRooms = filteredRooms.map((room) => ({
      id: room.value,
      title: room.label,
    }));
    setRooms(filteredRooms);
    setSecondRooms(resourceRooms);
    const updatedEndDate = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 2,
      2
    );
    getEvents({
      dateFrom: startDate,
      dateTo: updatedEndDate,
      selectedCity: selectedCity.value,
      selectedRooms: filteredRooms.map((room) => room.value),
      setEvents: (fetched) => {
        setRawEvents(fetched);
        setEvents(fetched);
      },
      accessToken: authToken,
    });
  } catch (error) {
    console.error("Error fetching city-specific data:", error);
  }
};
